import React, { useState, useRef, useEffect } from "react";

import { TabType } from "@constants";
import { Icon } from "@partials";
import { lowerCaseFirstLetter } from "@utilities";

import { IconsListProps, FiltersProps } from "../../../types";

import FormControl from "../FormControl";
import FilterCheckbox from "../FilterCheckbox";

type FiltersDesktopToggleAndDropdownProps = {
  type: TabType;
  name: string;
  viewport: string;
  text: string;
  handleOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & IconsListProps &
  FiltersProps;

const FiltersDesktopToggleAndDropdown: React.FC<FiltersDesktopToggleAndDropdownProps> = ({
  iconsList,
  type,
  name,
  viewport,
  text,
  filters,
  handleOnChange,
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutsideDropdown);

    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  // handle toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="filters-dropdown-container relative mr-[17.5px] last:mr-0" ref={dropdownRef}>
      {/* TOGGLE */}
      <div
        id={`filters-toggle-container-${viewport}-${type}-${name}`}
        className={`filters__toggle-container-${viewport} hidden sm:block`}
      >
        <div className="flex items-center">
          <button
            type="button"
            onClick={toggleDropdown}
            id={`filters-toggle-button-${viewport}-${type}-${name}`}
          >
            {text}
            <Icon
              name={iconsList.name}
              viewBox={iconsList.viewbox}
              alt={iconsList.alt}
              svg={iconsList.svg}
              className={`inline h-8 w-8 fill-red-corporate ${isOpen ? "rotate-180" : ""}`}
              id={`filters-toggle-button-icon-${viewport}-${type}-${name}`}
            />
          </button>
        </div>
      </div>

      {/* DROPDOWN */}
      <div
        id={`filters-dropdown-${viewport}-${type}-${name}`}
        className={`filters-dropdown-more-${viewport} ${isOpen ? "block" : "hidden"}`}
      >
        {filters.map((item) => {
          const itemValue = lowerCaseFirstLetter(item.value);

          return (
            <FormControl key={itemValue}>
              <FilterCheckbox
                isInsideDropdown
                type={type}
                id={`${viewport}-${itemValue}`}
                name={itemValue}
                checkboxValue={itemValue}
                defaultChecked={item.isChecked}
                label={item.name}
                handleOnChange={handleOnChange}
              />
            </FormControl>
          );
        })}
      </div>
    </div>
  );
};

export default FiltersDesktopToggleAndDropdown;
